<template>
  <div class="header__profile">
    <AppDropdown v-if="isLoggedIn" position="right" size="sm" variation="light">
      <template #trigger>
        {{ user?.email }}
      </template>

      <ul class="dropdown__list">
        <slot></slot>
        <li class="dropdown__item dropdown__item--sep">
          <ButtonLink @click="logout()">
            {{ $t("user.logout") }}
          </ButtonLink>
        </li>
      </ul>
    </AppDropdown>
    <AppButton v-else size="sm" variation="light" @click="openLoginModal()">
      {{ $t("user.loginRegister") }}
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import AppButton from "@/components/app-button.vue";
import { isLoggedIn, user, openLoginModal, logout } from "./store";
import AppDropdown from "@/components/app-dropdown.vue";
import ButtonLink from "@/components/button-link.vue";
</script>
